import { ContextualActionNames } from "./ContextualActionNames";

export interface ControlNamedContextualAction {
    type: "ContextualAction";
    contextualActionName: ContextualActionNames;
}
